export default {"src":"/_next/static/media/Flexible.ddc545c9.svg","height":80,"width":80,"blurWidth":0,"blurHeight":0};